import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DashboardIcon, UsersIcon, BoxesIcon, FileInvoiceIcon } from '../common/Icons';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  return (
    <div className={`sidebar bg-dark text-white ${isOpen ? 'sidebar-open' : ''}`}>
      <div className="sidebar-header p-3">
        <h4>SmartFacture</h4>
        <small>Gestion Commerciale</small>
      </div>
      
      <Nav className="flex-column">
        <Link to="/dashboard" className="nav-link text-white" onClick={onClose}>
          <DashboardIcon className="me-2" />
          Tableau de bord
        </Link>
        
        <Link to="/clients" className="nav-link text-white" onClick={onClose}>
          <UsersIcon className="me-2" />
          Clients
        </Link>
        
        <Link to="/suppliers" className="nav-link text-white" onClick={onClose}>
          <UsersIcon className="me-2" />
          Fournisseurs
        </Link>
        
        <Link to="/products" className="nav-link text-white" onClick={onClose}>
          <BoxesIcon className="me-2" />
          Produits
        </Link>
        
        <Link to="/stock" className="nav-link text-white" onClick={onClose}>
          <BoxesIcon className="me-2" />
          Stock
        </Link>
        
        <Link to="/quotes" className="nav-link text-white" onClick={onClose}>
          <FileInvoiceIcon className="me-2" />
          Devis
        </Link>
        
        <Link to="/invoices" className="nav-link text-white" onClick={onClose}>
          <FileInvoiceIcon className="me-2" />
          Factures
        </Link>
        
        <Link to="/deliveries" className="nav-link text-white" onClick={onClose}>
          <BoxesIcon className="me-2" />
          Livraisons
        </Link>
        
        <Link to="/payments" className="nav-link text-white" onClick={onClose}>
          <FileInvoiceIcon className="me-2" />
          Règlements
        </Link>
        
        <Link to="/checkbooks" className="nav-link text-white" onClick={onClose}>
          <FileInvoiceIcon className="me-2" />
          Carnets de chèques
        </Link>
        
        <Link to="/cautions" className="nav-link text-white" onClick={onClose}>
          <FileInvoiceIcon className="me-2" />
          Cautions
        </Link>
        
        <Link to="/settings" className="nav-link text-white" onClick={onClose}>
          <DashboardIcon className="me-2" />
          Paramètres
        </Link>
      </Nav>
    </div>
  );
};

export default Sidebar;